export enum Permission {
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
  BuildHorse = 'BuildHorse', // Build a horse
  FindHorse = 'FindHorse', // Find a horse, Find a partners
  BuildFoal = 'BuildFoal', // Build a foal
  OnlineReport = 'OnlineReport', // Access to online report
}
